/**
 * Retries the passed request for the specified number of milliseconds, before the promise resolved, or the
 * timeout expires.
 * @param asyncFn
 * @param timeoutMs
 * @param retryIntervalMs
 */
export async function retryRequestFor<T>(
  asyncFn: () => Promise<T>,
  timeoutMs: number,
  retryIntervalMs: number,
): Promise<T> {
  const start = Date.now();

  while (Date.now() - start < timeoutMs) {
    try {
      // eslint-disable-next-line no-await-in-loop
      return await asyncFn();
    } catch (error) {
      if (Date.now() - start + retryIntervalMs >= timeoutMs) {
        throw new Error(`Operation timed out after ${timeoutMs}ms`);
      }
      // eslint-disable-next-line no-await-in-loop
      await new Promise((resolve) => {
        setTimeout(resolve, retryIntervalMs);
      });
    }
  }

  throw new Error(`Operation timed out after ${timeoutMs}ms`);
}
